import React, { useMemo } from 'react';
import {
    GivelifyBox,
    GivelifyLabel,
    GivelifyLoading,
} from '@givelify/givelify-ui';
import { styled } from '@mui/material';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import matchingPercent from 'utils/matchingPercent';

interface Props {
    tooltipMessage: string;
    width?: number;
    maxWidth?: number;
    infoText?: string;
}

const Wrapper = styled(GivelifyBox)({
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridTemplateRows: 'auto auto',
    rowGap: '14px',
});

const Loading = styled(GivelifyLoading)({
    gridColumn: '1 / 3',
});

export const TooltipProgressBar: React.FCC<Props> = (props) => {
    const { infoText } = props;

    const { matchTotal, total } = useSelector((state: AppState) => ({
        matchTotal: state.Integrations.progressBarMatchedValue,
        total: state.Integrations.progressBarTotalValue,
    }));

    const percent = useMemo(
        () => matchingPercent(matchTotal, total),
        [matchTotal, total],
    );

    return (
        <Wrapper>
            <GivelifyLabel bold text={infoText} variant="body2" />
            <GivelifyLabel text={`${matchTotal} of ${total}`} variant="body2" />
            <Loading type="linear" value={percent} />
        </Wrapper>
    );
};
